var $ = require('jquery');

$(function () {
    var _ajax = $.ajax;

    $.extend({ 
        ajax: function (o) {
            o.url = o.url + (o.url.indexOf('?') === -1 ? '?' : '&') + 'sc_mode=normal';
            return _ajax.call(this,o); 
        }
    }); 
});